/* eslint-disable
    array-callback-return,
    consistent-return,
    no-inner-declarations,
    one-var,
    prefer-const
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS103: Rewrite code to no longer use __guard__
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from 'underscore';
import * as sequtil from 'molbio/SeqUtil';
import * as util from 'biojs/Util';
import * as AssemblyConstants from 'constants/AssemblyConstants';

const {ASSEMBLY_TYPE} = AssemblyConstants;

import * as shared from 'assembly/_shared';

const {basePlugin} = shared;

function checkAssembly(assembly) {
  const slots = assembly.slots();
  const allSeqsPresent = slots.all((slot) => {
    if (slot.isEmpty()) {
      return true;
    }
    return slot.singleFragment().getSequence() != null;
  });

  if (!allSeqsPresent) {
    return {warnings: [], errors: []};
  }

  // digest each sequence with the enzymes specified by the step (e.g. backbone, insert, etc.)
  const stepFragments = slots.map((slot) => {
    if (!slot.isEmpty()) {
      const sequence = slot.singleFragment().getSequence();
      return sequence.getFragments(slot.singleFragment().enzymeIDs());
    }
  });

  // eslint-disable-next-line no-restricted-syntax
  const cutsInMiddle = _.map(stepFragments, (fragments, i) => {
    // check if any of these fragments lie inside the user-selected fragment
    if (fragments != null) {
      const step = slots.at(i).singleFragment();
      const stepStart = step.start();
      const stepEnd = step.end();
      return fragments
        .chain()
        .map((fragment) => {
          let posInfo;
          const start = fragment.get('start');
          const end = fragment.get('end');
          if (stepStart !== start) {
            posInfo = [start, __guard__(fragment.get('_cutter5'), (x) => x.name)];
          } else if (stepEnd !== end) {
            posInfo = [end, __guard__(fragment.get('_cutter3'), (x1) => x1.name)];
          }

          if (posInfo != null && sequtil.isRangeWithin(start, end, stepStart, stepEnd)) {
            return posInfo;
          }
        })
        .without(undefined)
        .head()
        .value();
    }
  });

  const stepSelectedFragments = slots.map((slot, i) => {
    // create the fragment selected by the user
    if (!slot.isEmpty()) {
      const fragments = stepFragments[i];
      const fragment = slot.singleFragment().getSelectedFragment(fragments);
      slot.set({sequenceFragment: fragment});
      return fragment;
    }
  });

  // eslint-disable-next-line no-restricted-syntax
  const stepRevCompFragments = _.map(stepSelectedFragments, (seq) =>
    seq != null ? seq.cloneReverseComplement() : undefined
  );

  const doCutsMatch = (ordering, setMatched) =>
    // check if sticky ends match up for a specified ordering
    // ordering is a list of tuples [fragment index, reversed]
    __range__(0, slots.length, false).map((i) => {
      const prevIndex = i === 0 ? slots.length - 1 : i - 1;
      const nextIndex = (i + 1) % slots.length;

      function getFragment(info) {
        if (info[1]) {
          return stepRevCompFragments[info[0]];
        } else {
          return stepSelectedFragments[info[0]];
        }
      }

      const prevFragment = getFragment(ordering[prevIndex]);
      const nextFragment = getFragment(ordering[nextIndex]);
      const thisFragment = getFragment(ordering[i]);
      const prevMatched = util.stickyCompatible(prevFragment, thisFragment);
      const nextMatched = util.stickyCompatible(thisFragment, nextFragment);

      if (setMatched) {
        const slot = slots.at(i);
        slot.set({
          prevMatched,
          nextMatched,
          thisFragment,
          prevFragment,
          nextFragment,
        });
      }
      return [prevMatched, nextMatched];
    });

  // eslint-disable-next-line no-restricted-syntax
  const currentOrdering = _.map(__range__(0, slots.length, false), (i) => {
    const slot = slots.at(i);
    const reversed = slot.isEmpty() ? null : slot.singleFragment().reverse();
    return [i, reversed];
  });

  const invalidCutSites = (slot) => !slot.isEmpty() && slot.get('thisFragment') == null;

  const matchedCuts = doCutsMatch(currentOrdering, true);
  slots.each((slot, i) => {
    const warnings = [];
    const errors = [];
    if (invalidCutSites(slot)) {
      errors.push('Selected cut sites are no longer valid - reset slot to continue.');
    }
    if (cutsInMiddle[i] != null) {
      let [pos, name] = Array.from(cutsInMiddle[i]);
      pos = sequtil.modelToDisplay(pos, slot.singleFragment().getSequence().startIndex());
      const msg = `${name} has a cut site in the middle at position ${pos}.`;
      warnings.push(msg);
    }
    const [upMatch, downMatch] = Array.from(matchedCuts[i]);
    if (!upMatch) {
      errors.push('The left sticky end does not match.');
    }
    if (!downMatch) {
      errors.push('The right sticky end does not match.');
    }
    slot.set({
      warnings,
      errors,
    });
  });

  const warnings = [];
  const errors = [];
  const allSet = slots.all((slot) => !slot.isEmpty());
  if (allSet) {
    if (!_.chain(matchedCuts).flatten().all().value()) {
      errors.push('Sticky ends are mismatched.');
    }
    // remove the first and the last since they're just the original ordering
    const permutations = _.chain(_permuteWithRev(__range__(0, slots.length, false), slots))
      .initial()
      .rest()
      .value();
    // eslint-disable-next-line no-restricted-syntax
    const otherOrderMatches = _.map(permutations, (ordering) =>
      _.chain(doCutsMatch(ordering, false)).flatten().all().value()
    );
    // eslint-disable-next-line no-restricted-syntax
    const matched = _.find(__range__(0, permutations.length, false), (i) => otherOrderMatches[i]);
    if (matched != null) {
      const ordering = permutations[matched];

      function getName(info) {
        const [index, reversed] = Array.from(info);
        const basic = index === 0 ? 'backbone' : `insert #${index}`;
        if (reversed) {
          return `reversed ${basic}`;
        }
        return basic;
      }

      // eslint-disable-next-line no-restricted-syntax
      const startIndex = _.find(__range__(0, ordering.length, false), (i) => ordering[i][0] === 0);
      // eslint-disable-next-line no-restricted-syntax
      const fullName = _.map(__range__(0, ordering.length, false), (i) => {
        const index = (startIndex + i) % ordering.length;
        return getName(ordering[index]);
      }).join(', ');
      warnings.push(`An alternative ordering (${fullName}) has matching sticky ends.`);
    }
  } else {
    errors.push('The backbone or an insert is unset.');
  }

  const bluntEnds = _.chain(stepSelectedFragments)
    .map((fragment) => fragment != null && (fragment.get('offset5') === 0 || fragment.get('offset3') === 0))
    .any()
    .value();
  if (bluntEnds) {
    warnings.push('You are using blunt ends.');
  }

  for (const slot of Array.from(slots.models)) {
    if (invalidCutSites(slot)) {
      errors.push('One or more slots have invalid cut sites.');
      break;
    }
  }

  return {
    errors,
    warnings,
  };
}

function _permuteWithRev(lst, slots) {
  // ordering is a list of tuples [fragment index, reversed]
  let index, reversed;
  if (lst.length === 0) {
    return [[]];
  } else if (lst.length === 1) {
    index = lst[0];
    reversed = slots.at(index).singleFragment().reverse();
    return [[[lst[0], reversed]], [[lst[0], !reversed]]];
  } else {
    const results = [];
    for (const perm of Array.from(_permuteWithRev(lst.slice(1), slots))) {
      index = lst[0];
      reversed = slots.at(index).singleFragment().reverse();
      for (let i = 0; i < lst.length - 1; i++) {
        // -1 to avoid circular permutations
        results.push(
          perm
            .slice(0, i)
            .concat([[index, reversed]])
            .concat(perm.slice(i))
        );
        results.push(
          perm
            .slice(0, i)
            .concat([[index, !reversed]])
            .concat(perm.slice(i))
        );
      }
    }
    return results;
  }
}

// eslint-disable-next-line no-restricted-syntax
export const plugin = _.extend({}, basePlugin, {
  assemblyType: ASSEMBLY_TYPE.DIGEST,
  checkAssembly,
});

function __guard__(value, transform) {
  return value != null ? transform(value) : undefined;
}
function __range__(left, right, inclusive) {
  const range = [];
  const ascending = left < right;
  const end = !inclusive ? right : ascending ? right + 1 : right - 1;
  for (let i = left; ascending ? i < end : i > end; ascending ? i++ : i--) {
    range.push(i);
  }
  return range;
}
